import { render } from "./ListaVincularCa.vue?vue&type=template&id=255343c9&scoped=true"
import script from "./ListaVincularCa.vue?vue&type=script&lang=js"
export * from "./ListaVincularCa.vue?vue&type=script&lang=js"

import "./ListaVincularCa.vue?vue&type=style&index=0&id=255343c9&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255343c9"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QImg,QBtn,QInput,QIcon,QTr,QTh,QTd,QPagination});
